import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import { getAxiosCancelToken } from "../../../utils/getAxiosCancelToken";
import apiRequestType from "../../apiRequestType";

let cancelToken;
const getAllNotificationHistory = (
  searchText,
  pageNumber,
  pageSize,
  from,
  to
) => {
  cancelToken = getAxiosCancelToken(cancelToken);
  return apiRequestType(
    apiTypes.GET,
    apiConstants.ADMIN.ENGAGEMENT_CENTER.GET_ALL_NOTIFICATIONS_HISTORY(
      searchText,
      pageNumber,
      pageSize,
      from,
      to
    ),
    "",
    cancelToken
  );
};

export default getAllNotificationHistory;
